export enum RouteOfAdminstrationEnum {
  SKIN = "1",
  ORAL = "2",
  INJECTION = "3",
  OTHER = "4"
}

export enum TreatmentTypeEnum {
  ALLOPATHY = "1",
  AYURVEDA = "2",
  HOMEPATHY = "3",
  HERBAL = "4"
}

export enum AgeRestrictionEnum {
  AGE_0_5 = "1",
  AGE_6_15 = "2",
  AGE_16_25 = "3",
  AGE_25_40 = "4",
  AGE_40_55 = "5",
  AGE_55_above = "6",
  AGE_all = "7" 
}

export enum MedicineCategoryEnum {
  TABLET = "1",
  CAPSULES = "2",
  SYRUP = "3",
  ORALSOLUTION = "4",
  ORALSUSPENSION = "5",
  ORALDROPS = "6",
  INJECTION = "7",
  OINTMENT = "8",
  CHEWABLETABLETS = "9",
  KIT = "10",
  PUMP = "11",
  DROPS = "12",
  MOUTHWASH = "13",
  LOTION = "14",
  CREAM = "15",
  GEL = "16",
  SOAP = "17",
  SYRINGE = "18",
  EYE_EARDROP = "19",
  NASALSPRAY = "20",
  PACKET = "21",
  INHALER = "22"
}

export interface Medicine {
  _id: string;
  medicine_name: string;
  dosage: string;
  price?: number;
  manufacturer_name: string;
  side_effect: string;
  active_medicine?: boolean;
  route_of_adminstration?: RouteOfAdminstrationEnum;
  treatment_type?: TreatmentTypeEnum;
  age_restriction: AgeRestrictionEnum;
  medicine_category: MedicineCategoryEnum;
  chemical_composition?: string;
  additional_info?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateMedicineDto {
  medicine_name: string;
  dosage: string;
  price?: number;
  manufacturer_name: string;
  side_effect: string;
  active_medicine: boolean;
  route_of_adminstration?: RouteOfAdminstrationEnum;
  treatment_type?: TreatmentTypeEnum;
  age_restriction: AgeRestrictionEnum;
  medicine_category: MedicineCategoryEnum;
  chemical_composition?: string;
  additional_info?: string;
}

export function formatEnumKeyToLabel(key: string): string {
  if (key.startsWith("AGE_")) {
    const agePart = key.replace("AGE_", "");
    if (agePart.toLowerCase() === "all") {
      return "All Ages";
    }
    return agePart.replace(/_/g, "-");
  }
  return key
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}